import { findSkuDetail } from "../../utils/findSkuDetail";
import INVENTORY_API_BASE_URL from "../../config/api";
import  { useState, useEffect, useRef } from "react";
import Axios from "axios";
import { useReactToPrint } from "react-to-print";
import Barcode from "react-barcode";
import Table from "react-bootstrap/Table";

const Cancelsticker = () => {
  const [data2, setData] = useState([]);
  const [barcodeData, setBarcodeData] = useState([]);
  const [selectedTimestamp, setSelectedTimestamp] = useState(null);
  const [details, setDetails] = useState([]);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/CorrectBarcode`)
      .then((response) => {
        const latestDocuments = response.data.latestDocuments;
        if (Array.isArray(latestDocuments)) {
          setData(latestDocuments);
        } else {
          console.error("Unexpected data format:", response.data);
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setData([]);
      });
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`).then((response) => {
      const filteredData = response.data.map((item) => ({
        sku: item.sku,
        title: item.title,
        Medium: item.Medium,
        edition: item.edition,
      }));
      setDetails(filteredData);
    });
  }, []);

  const handleTimestampClick = (timestamp) => {
    setSelectedTimestamp(timestamp);
    const selectedData = data2.find(
      (batch) => new Date(batch.timestamp).toLocaleString() === timestamp
    );
    if (selectedData) {
      const formattedData = selectedData.updates.map((update) => {
        const matchingDetail = findSkuDetail(details, update.keyValue);
        return {
          originalValue: update.originalValue,
          correctedValue: update.correctedValue,
          keyValue: update.keyValue,
          detail: matchingDetail || null,
        };
      });
      setBarcodeData(formattedData);
    } else {
      setBarcodeData([]);
    }
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "barcode",
  });

  return (
    <div style={{ padding: "2rem", fontFamily: "Arial, sans-serif", backgroundColor: "#f9f9f9" }}>
      <h4 style={{ marginLeft: '40rem', marginTop: '3rem' }}>Print Barcodes</h4>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "2rem" }}>
      <select
            onChange={(e) => handleTimestampClick(e.target.value)}
            style={{
              padding: "0.5rem 1rem",
              borderRadius: "5px",
              border: "1px solid #ccc",
              width: "300px",
              fontSize: "1rem",
              marginLeft: "5rem",
              marginTop: "1rem",
            }}
          >
            <option value="">Select Batch ID & Timestamp</option>
            {data2.map((batch) => (
              <option
                key={batch.timestamp}
                value={new Date(batch.timestamp).toLocaleString()}
              >
                {`Batch ID: ${batch.batchId} | ${new Date(batch.timestamp).toLocaleString()}`}
              </option>
            ))}
          </select>

      </div>

      {selectedTimestamp && (
        <Table
          striped
          bordered
          hover
          style={{
            width: "50%",
            marginLeft: "30rem",
            margin: "0 auto 2rem auto",
            textAlign: "center",
            backgroundColor: "#fff",
          }}
        >
          <thead style={{ backgroundColor: "#333", color: "#fff" }}>
            <tr>
              <th>Serial Number</th>
              <th>New Sticker Value</th>
              <th>Key Value</th>
            </tr>
          </thead>
          <tbody>
            {barcodeData.map(({correctedValue, keyValue }, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{correctedValue}</td>
                <td>{keyValue}</td> 
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {selectedTimestamp && (
        <div ref={componentRef} className="serialbarcode">
          {barcodeData.map(({ correctedValue, detail }, index) => (
            <div className="codeContainer" key={index}>
              {detail ? (
                <>
                  <p className="barcodetitle">{detail.title.substring(0, 30)}</p>
                  <p className="barcodeMedium">{detail.Medium} {detail.edition}</p>
                </>
              ) : (
                <p className="barcodeMedium">No Title Found</p>
              )}
              <div style={{ fontFamily: "Roboto" }}>
                <Barcode
                  height="26rem"
                  width="1rem"
                  fontSize="13rem"
                  marginLeft="1rem"
                  value={correctedValue}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {selectedTimestamp && (
        <button className="printbtn" onClick={handlePrint}>
          Print Barcode
        </button>
      )}
    </div>
  );
};

export default Cancelsticker;
